import * as types from "../actions/types";



const initialState = {
  list: null,
  loading: false,
  adsById: null
};


export default function types_of_documents(state = initialState, action) {
  switch (action.type) {
    case types.SET_TYPES_OF_DOCUMENTS_LIST:
      return {
        ...state,
        typeOfDocumentslist: action.payload
      };
    case types.SET_TYPES_OF_DOCUMENTS_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    default:
      return state;
  }
}